var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49858 5.24929C4.49858 4.55933 3.93925 4 3.24929 4C2.55933 4 2 4.55933 2 5.24929C2 5.93925 2.55933 6.49858 3.24929 6.49858C3.93925 6.49858 4.49858 5.93925 4.49858 5.24929Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24929 9C3.93925 9 4.49858 9.55933 4.49858 10.2493C4.49858 10.9393 3.93925 11.4986 3.24929 11.4986C2.55933 11.4986 2 10.9393 2 10.2493C2 9.55933 2.55933 9 3.24929 9Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11C6.33579 11 6 10.6642 6 10.25C6 9.8703 6.28215 9.55651 6.64823 9.50685L6.75 9.5H21.25C21.6642 9.5 22 9.83579 22 10.25C22 10.6297 21.7178 10.9435 21.3518 10.9932L21.25 11H6.75Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24929 14C3.93925 14 4.49858 14.5593 4.49858 15.2493C4.49858 15.9393 3.93925 16.4986 3.24929 16.4986C2.55933 16.4986 2 15.9393 2 15.2493C2 14.5593 2.55933 14 3.24929 14Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.5H11.7322C11.4876 14.9693 11.2986 15.4722 11.1739 16H6.75C6.33579 16 6 15.6642 6 15.25C6 14.8703 6.28215 14.5565 6.64823 14.5068L6.75 14.5Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 4.5H21.25C21.6642 4.5 22 4.83579 22 5.25C22 5.6297 21.7178 5.94349 21.3518 5.99315L21.25 6H6.75C6.33579 6 6 5.66421 6 5.25C6 4.8703 6.28215 4.55651 6.64823 4.50685L6.75 4.5Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.5C23 14.4624 20.5376 12 17.5 12C14.4624 12 12 14.4624 12 17.5C12 20.5376 14.4624 23 17.5 23C20.5376 23 23 20.5376 23 17.5ZM18.0006 18L18.0011 20.5035C18.0011 20.7797 17.7773 21.0035 17.5011 21.0035C17.225 21.0035 17.0011 20.7797 17.0011 20.5035L17.0006 18H14.4961C14.22 18 13.9961 17.7762 13.9961 17.5C13.9961 17.2239 14.22 17 14.4961 17H17.0005L17 14.4993C17 14.2231 17.2239 13.9993 17.5 13.9993C17.7761 13.9993 18 14.2231 18 14.4993L18.0005 17H20.503C20.7792 17 21.003 17.2239 21.003 17.5C21.003 17.7762 20.7792 18 20.503 18H18.0006Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAdd);
export default __webpack_public_path__ + "static/media/list-add.e154902a2239547e9dbcb96d593a5720.svg";
export { ForwardRef as ReactComponent };